<template>
  <KDSList />
</template>

<script>
import KDSList from "../partials/kds.vue";

export default {
  name:'KDS',
  components: { KDSList }
};
</script>
